import { useEffect, useState } from "react"

/**
 * « A-t-on entendu quelque chose ? » — et non « entend-on quelque chose à cet
 * instant ». Le verdict du micro doit se verrouiller au vert dès le premier son
 * capté : sinon la ligne repasserait à l'orange chaque fois que l'élève arrête
 * de parler, ce qui donnerait l'impression que le micro lâche par intermittence.
 *
 * Le seuil est volontairement bas : on cherche à distinguer un micro coupé d'un
 * micro qui fonctionne, pas à juger du volume.
 *
 * Pas de remise à zéro ici : le composant qui appelle ce hook n'est monté que
 * pendant l'étape micro et que si l'accès est accordé. Une nouvelle
 * vérification le démonte, donc le verrou repart naturellement de zéro. La
 * clé de réinitialisation qui vivait ici ne pouvait jamais changer de valeur —
 * et le vrai verrou de parcours est ailleurs, dans le panneau.
 */

export const SIGNAL_THRESHOLD = 0.06

export const useMicSignal = (micLevel) => {
    const [hasSignal, setHasSignal] = useState(false)

    useEffect(() => {
        if (!hasSignal && micLevel > SIGNAL_THRESHOLD) setHasSignal(true)
    }, [micLevel, hasSignal])

    return hasSignal
}
